module.exports = __webpack_public_path__ + "static/media/logo.436bc572.png";